import misRutas from 'vue-routes-generator'
import GestionGrupos from './app'

export default {
	install: Vue => {
		misRutas.route('/main').child('panel-control').child('grupos-usuario', {
			name: 'Gestión de grupos de usuario',
			component: GestionGrupos
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-grupos/vue/index.js